export const config = {
  // @ts-ignore
  apiKey: process.env.REACT_APP_API_KEY || "",
};
